export default __webpack_public_path__ + "static/media/one.8a8fe096.svg";